module.exports = __webpack_public_path__ + "static/img/icon_star.e7fe58ab.svg";